"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const FileAdd = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 18,
  viewBox: "0 0 16 18",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.667 5.5a.833.833 0 01-.834-.833V2.67c0-.186.225-.279.356-.148l2.622 2.622a.208.208 0 01-.147.356H7.667zM8.134.622A.417.417 0 007.839.5H1.833C.914.5.167 1.248.167 2.167v11.666c0 .92.747 1.667 1.666 1.667h5.07a5 5 0 014.93-5.833V4.494a.417.417 0 00-.122-.294L8.134.622zM2.667 7.167a.833.833 0 100 1.666h4.166a.833.833 0 100-1.666H2.667zm-.834 4.166c0-.46.373-.833.834-.833h2.5a.833.833 0 010 1.667h-2.5a.833.833 0 01-.834-.834zm9.167.834a.833.833 0 111.667 0v1.666h1.666a.833.833 0 110 1.667h-1.666v1.667a.833.833 0 01-1.667 0V15.5H9.333a.833.833 0 010-1.667H11v-1.666z",
  fill: "#1973E8",
  className: "fill"
}));

var _default = FileAdd;
exports.default = _default;